import { SecureStorageKey } from './secure-storage-key.enum';

enum Keys {
	InitialAppLaunch = 'initialAppLaunch'
}

export const StorageKey = { ...SecureStorageKey, ...Keys };
export type StorageKey = SecureStorageKey | Keys;
